
import startCase from "lodash/startCase";
import { Component, Vue } from "vue-property-decorator";
import { AppTileButton, ButtonState } from "@/components/shared/app-tile-button.vue";
import { AppMode } from "@/store/modules/scan";
import { hasAccess } from "@/helpers/access-rights";
import { uiInfoText } from "@/helpers/ui-info-text";
import homeLogoSrc from "@/assets/gigalot-feedlot-solutions-logo.svg";

@Component({
  components: {
    AppTileButton,
  },
})
export default class Home extends Vue {
  //numYetToUpload: number = 0;

  hasAccess = hasAccess;
  homeLogoSrc = homeLogoSrc;

  created() {
    this.$store.commit("navFuncs", { save: undefined, back: undefined });

    this.$store.dispatch("upload/getNumYetToUpload");
  }

  buttonState(appMode: AppMode) {
    return this.$store.getters["scan/isAppModeAllowedToContinue"](appMode) ? "ready" : "disabled";
  }

  isScanningBeingUsed() {
    return this.$store.getters["scan/isAppModeValidWithTagsScanned"]();
  }

  get dataSyncButtonState(): ButtonState {
    if (this.$store.state.sync.state === "success") return "success";
    return "ready";
  }

  uiFriendlyAppMode(appMode: AppMode) {
    return startCase(appMode);
  }

  onClickDisabled(appModeDesired: AppMode) {
    let appModeCurrent = this.$store.state.scan.appMode;
    let message: string;
    if (appModeCurrent === "count-without-save") {
      message = this.uiFriendlyAppMode(appModeDesired) + " disabled. You must first clear the tags in " + this.uiFriendlyAppMode("count-without-save");
    } else {
      message = this.uiFriendlyAppMode(appModeDesired) + " disabled. You must first clear or save the tags in " + this.uiFriendlyAppMode(appModeCurrent);
    }
    this.$store.commit("popup/displayOk", message);
  }

  onClickInfo(title: string) {
    const info = uiInfoText[title as keyof typeof uiInfoText];
    this.$store.commit("popup/displayOk", {
      title,
      bullets: info ? info.bullets : ["No info available"],
    });
  }

  onClickLogout() {
    this.$store.commit("popup/displayYesNo", {
      message: "Are you sure you want to log out?",
      yesAction: () => {
        this.$store.dispatch("user/signOut");
      },
    });
  }
}
